import React from 'react'
import {
    Box,
    Text,
    Link,
    Input,
    Button,
} from '@chakra-ui/react'

export default function SubscribeBlock() {
    return (
        <Box>
            <form action="https://gmail.us4.list-manage.com/subscribe/post?u=d90a8de50bb2c3b942acdde99&amp;id=52558994af" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
                <Text>
                    <Link href="mailto:contact.overbuild@gmail.com" alt="寄信給頂樓加蓋" target="_blank">
                        寄信給我們：contact.overbuild@gmail.com
                    </Link>
                </Text>
                <Text>
                    只會在有新集數和重大消息宣布時才寄信給你，不用擔心收到騷擾的廣告信。
                </Text>
                <Box paddingTop={2}>
                    <Input type="email" className="input" placeholder="Email" name="EMAIL" id="mce-EMAIL" />
                </Box>
                <Box paddingTop={2}>
                    <Input type="text" className="input" placeholder="我們該怎麼稱呼你" name="NICKNAME" id="mce-NICKNAME" />
                </Box>
                <Box paddingTop={2}>
                    <Button type="submit" colorScheme="teal" value="Subscribe" name="subscribe" id="mc-embedded-subscribe">
                        Subscribe
                    </Button>
                </Box>

            </form>
        </Box>
    )
}
